/* eslint-disable */
import React, { useState, useEffect } from 'react'
import { Table, Row, Col } from 'antd'
import * as R from 'ramda'
import i2Math from '@/utils/i2Math'
import { FrownOutlined } from '@ant-design/icons'

import { Waypoint } from 'react-waypoint'

const TableFixed = (props) => {
  const { children, columns, fixedTable } = props
  const [ useFixed, setUseFixed ] = useState(false)
  const [ useVisible, setUseVisible ] = useState(false)
  const [ useChildren, setUseChildren ] = useState([])
  useEffect(() => {
    const flattenChildren = children ? R.flatten(children) : columns
    setUseChildren(flattenChildren)
    if (fixedTable) {
      setUseFixed(true)
    }
  }, [])

  const waypoint = () => {
    if (!useFixed) {return false }
    return (
      <Waypoint
        onEnter={() => setUseVisible(false)}
        onLeave={() => setUseVisible(true)}
      />
    )
  }

  const renderTableHeadChildren = (record) => {
    const totalWidth = (record || []).map(item => (
      item.width
    )).reduce((sum, value) => i2Math.i2Add(sum, value), 0)
    return <Row className='i2-table-fixed-children'>
      {record.map((r) => {
        const formatSpan = i2Math.i2Multiply(i2Math.i2Division(r.width, totalWidth), 24)
        return (
          <Col span={formatSpan} key={r.title}>{r.title}</Col>
        )
      })}
    </Row>
  }

  const fixedHeader = () => {
    if (!useVisible) { return false }
    return (
      <div
        className={`i2-table-fixed visible`}
      >
        <table className="ant-table">
          <tbody className="ant-table-thead">
            <tr>
              {
                useChildren.map((c) => {
                  const childValues = c.props ? c.props : c
                  if (childValues) {
                    return (
                      <th key={childValues.title} width={childValues.width}>
                        {childValues.title}
                        {childValues.children && renderTableHeadChildren(childValues.children)}
                      </th>
                    )
                  }
                })
              }
            </tr>
          </tbody>
        </table>
      </div>
    )
  }

  return (
    <div>
      {/* {waypoint()}
      {fixedHeader()} */}
      <Table
        className='i2-table'
        size="small"
        bordered
        locale={{
          emptyText: (
            <div>
              <FrownOutlined /> 暂无数据
            </div>
          )
        }}
        {...props}
      >
        {useChildren}
      </Table>
    </div>
  )
}

export default TableFixed
